// extracted by mini-css-extract-plugin
module.exports = {"ul":"styles_ul__y6KHK"};